import { BaseEntity } from ".";
import moment from "moment";
import { CorporationsProjectsDetailProject } from "../client/types.gen";

export class CorporationProjectListEntity extends BaseEntity {
  constructor(id: number, props: any) {
    super(id, props);
    this._dataTypeName = "Corporation Project";
  }

  async toJson(): Promise<Excel.EntityCellValue> {
    const props: Partial<CorporationsProjectsDetailProject> = this.props;
    var entity = await super.toJson();
    // Properties
    if (entity.properties) {
      if (props.id) {
        entity.properties["project_id"] = {
          type: Excel.CellValueType.string,
          basicValue: props.id,
        };
      }
      let name = "Unknown Project Name";
      if (props.name) {
        name = props.name.toString();
      }
      if (props.last_modified) {
        const last_modified = moment(props.last_modified);
        entity.properties["last_modified"] = {
          type: Excel.CellValueType.formattedNumber,
          basicValue: last_modified.unix() / 86400 + 25569,
          numberFormat: "[$-409]m/d/yy h:mm AM/PM;@",
        };
      }
      entity.properties["progress_current"] = {
        type: Excel.CellValueType.double,
        basicValue: props.progress?.current ?? 0,
      };
      entity.properties["progress_desired"] = {
        type: Excel.CellValueType.double,
        basicValue: props.progress?.desired ?? 0,
      };

      entity.properties["reward_remaining"] = {
        type: Excel.CellValueType.double,
        basicValue: props.reward?.remaining ?? 0,
      };
      entity.properties["reward_initial"] = {
        type: Excel.CellValueType.double,
        basicValue: props.reward?.initial ?? 0,
      };
      if (props.state) {
        entity.properties["state"] = {
          type: Excel.CellValueType.string,
          basicValue: props.state,
        };
      }
      entity.text = name;
      entity.properties["name"] = {
        type: Excel.CellValueType.string,
        basicValue: entity.text,
      };
    }
    // Layouts
    entity.layouts = {
      card: {
        //title: { property: "name" },
      },
    };

    return entity;
  }
}
